module.exports = __webpack_public_path__ + "img/IAR11.1.48b8571f.png";